// Utilities
import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const RemoveMemberDialogContainerLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "planner-removememberdialogcontainer" */ "./RemoveMemberDialogContainer")).then((bundle)=>{
        return {
            default: bundle.RemoveMemberDialogContainer
        };
    });
export const LazyRemoveMemberDialogContainer = /*#__PURE__*/ lazy(RemoveMemberDialogContainerLazyLoader);
